/**
 * Google Tag Manager (GTM) dataLayer event helper for PRROPERTIES.AE
 * Sends structured events to GTM container GTM-PHQ955Z6
 */
export const trackGtmEvent = (eventName, eventParams = {}) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    });
  }
};
